import i18n from '@/i18n'

export default [
  {
    path: '/account-watch-list',
    component: () => import(/* webpackChunkName: "AccountWatchList" */ '@/views/AccountWatchList.vue'),
    meta: {
      noContextRequired: true
    },
    children: [
      {
        path: '',
        name: 'accountWatchList',
        component: () => import(/* webpackChunkName: "AccountWatchList" */ '@/components/AccountWatchList/Overview/AccountWatchListOverview.vue'),
        meta: {
          permissions: ['Mapi.AccountWatchList.Read'],
          menu: {
            index: 90,
            routeName: 'accountWatchList',
            activeWhen: ['accountWatchList'],
            title: i18n.t('label.accountWatchList'),
            icon: ['fal', 'binoculars']
          }
        }
      }
    ]
  }
]
